import React from 'react';

import { Box, ButtonGroup } from '@mui/material';
import { useWatch } from 'react-hook-form';

import { FORM_FIELD_TYPES, FormField } from '../../../components/form/form-field';
import SaveButton from '../../../components/form/save-button';
import SchemaEditor from '../../../components/form/schema-editor';
import { useNodeContext } from '../../../context/node-context';

const SalesforceV2ReaderForm = ({ form, onSubmit, onChange }) => {
  const { errors } = form.formState;
  const formControl = form.control;
  const { node } = useNodeContext();
  const { id } = node;

  const useBearerToken = useWatch({
    control: formControl,
    name: 'properties.useBearerToken',
    defaultValue: false,
  });

  return (
    <Box
      component="form"
      onSubmit={form.handleSubmit(onSubmit)}
      onReset={form.reset}
      onChange={onChange}
    >
      <FormField
        controlId="salesforceV2ReaderFormName"
        label="name"
        name="name"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter name"
        required
        error={errors?.name?.message}
      />
      <FormField
        controlId="salesforceV2ReaderFormType"
        label="type"
        name="type"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        disabled
        error={errors?.type?.message}
      />
      <FormField
        controlId="salesforceV2ReaderFormDelayedRead"
        label="delayedRead"
        name="delayedRead"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
      />
      <FormField
        controlId="salesforceV2ReaderFormConnectionKey"
        label="connectionKey"
        name="connectionKey"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter connection key"
        error={errors?.connectionKey?.message}
      />
      <FormField
        controlId="salesforceV2ReaderFormParameterizedBy"
        label="parameterizedBy"
        name="parameterizedBy"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter parameterization"
        error={errors?.parameterizedBy?.message}
      />
      <FormField
        controlId="salesforceV2ReaderFormFormat"
        label="format"
        name="format"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter file format"
        error={errors?.format?.message}
      />
      <FormField
        controlId="salesforceV2ReaderFormApiVersion"
        label="apiVersion"
        name="properties.apiVersion"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter API Version"
        error={errors?.properties?.apiVersion?.message}
      />
      <FormField
        controlId="salesforceV2ReaderFormUseBearerToken"
        label="useBearerToken"
        name="properties.useBearerToken"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
        error={errors?.properties?.useBearerToken?.message}
      />
      {!useBearerToken && (
        <>
          <FormField
            controlId="salesforceV2ReaderFormUsername"
            label="username"
            name="properties.username"
            control={formControl}
            fieldComponentType={FORM_FIELD_TYPES.TEXT}
            placeholder="Enter Username"
            required
            error={errors?.properties?.username?.message}
          />
          <FormField
            controlId="salesforceV2ReaderFormPassword"
            label="password"
            name="properties.password"
            control={formControl}
            fieldComponentType={FORM_FIELD_TYPES.TEXT}
            type="password"
            placeholder="Enter Password"
            required
            error={errors?.properties?.password?.message}
          />
        </>
      )}
      <FormField
        controlId="salesforceV2ReaderFormIsSandbox"
        label="isSandbox"
        name="properties.isSandbox"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.CHECKBOX}
        error={errors?.properties?.isSandbox?.message}
      />
      <FormField
        controlId="salesforceV2ReaderFormQuery"
        label="query"
        name="properties.query"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.SPARKQL}
        placeholder="Enter Query"
        required
        rows={10}
        error={errors?.properties?.query?.message}
      />
      <FormField
        controlId="salesforceV2ReaderFormCharsToBeEncoded"
        label="charsToBeEncoded"
        name="properties.charsToBeEncoded"
        control={formControl}
        fieldComponentType={FORM_FIELD_TYPES.TEXT}
        placeholder="Enter Characters to be Encoded"
        error={errors?.properties?.charsToBeEncoded?.message}
      />
      <SchemaEditor form={form} id={id} />
      <ButtonGroup>
        <SaveButton />
      </ButtonGroup>
    </Box>
  );
};

export default SalesforceV2ReaderForm;
